import { number, shape, string } from "prop-types";

const CostAttributeShape = shape({
  id: number,
  cost: number,
  excess_cost: number,
  trade: string
});
export default CostAttributeShape;
